{
  "actions": "Handlinger",
  "actionsAvailable": "Tilgængelige handlinger.",
  "clearSelection": "Ryd markering",
  "selected": "{count, plural, =0 {Ingen valgt} other {# valgt}}",
  "selectedAll": "Alle valgt"
}
